import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";

export default function CreditBasedDiscountRequested(props) {
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const headers = [[]];

    if (props.type == "Quotes") {
        headers[0] = [
            "Quote Type",
            "Total Quotes",
            <>700+ (%)<TooltipButton tooltipText="% of total quotes" /></>,
            "Avg Prem",
            "Bind %",
            <>600-699 (%)<TooltipButton tooltipText="% of total quotes" /></>,
            "Avg Prem",
            "Bind %",
            <>599 And Under (%)<TooltipButton tooltipText="% of total quotes" /></>,
            "Avg Prem",
            "Bind %",
            <>No Hit (%)<TooltipButton tooltipText="% of total quotes" /></>,
            "Avg Prem",
            "Bind %",
        ];
    } else { // Policies
        headers[0] = [
            "Policy Type",
            "Total Policies",
            <>700+ (%)<TooltipButton tooltipText="% of total policies" /></>,
            "Avg Prem",
            <>600-699 (%)<TooltipButton tooltipText="% of total policies" /></>,
            "Avg Prem",
            <>599 And Under (%)<TooltipButton tooltipText="% of total policies" /></>,
            "Avg Prem",
            <>No Hit (%)<TooltipButton tooltipText="% of total policies" /></>,
            "Avg Prem",
        ];
    }

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
        
    const GetData = async () => {
        const response = await CallAPI("POST", `/Home/Get${props.type}CreditBasedDiscountRequested`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            getQuoteType: props.getQuoteType
        });
        
        if (response) {
            let formattedResponse;
            if (props.type == "Quotes") {
                formattedResponse = [["Quick"], ["Custom"], ["CRC"], ["Agency"], ["TOTAL"]];
                formattedResponse.forEach(function (item) {
                    var row = response.find(x => x.quoteType == item[0]);
                    item.push(...[
                        integer.format(row?.totalQuotes ?? 0),
                        `${integer.format(row?.quotes700AndOver ?? 0)} (${percent.format((row?.percentage700AndOver ?? 0) / 100)})`,
                        currency.format(row?.avgPrem700AndOver ?? 0),
                        percent.format((row?.bindPercentage700AndOver ?? 0) / 100),
                        `${integer.format(row?.quotes600To699 ?? 0)} (${percent.format((row?.percentage600To699 ?? 0) / 100)})`,
                        currency.format(row?.avgPrem600To699 ?? 0),
                        percent.format((row?.bindPercentage600To699 ?? 0) / 100),
                        `${integer.format(row?.quotes599AndUnder ?? 0)} (${percent.format((row?.percentage599AndUnder ?? 0) / 100)})`,
                        currency.format(row?.avgPrem599AndUnder ?? 0),
                        percent.format((row?.bindPercentage599AndUnder?? 0) / 100),
                        `${integer.format(row?.quotesNoHit ?? 0)} (${percent.format((row?.percentageNoHit ?? 0) / 100)})`,
                        currency.format(row?.avgPremNoHit ?? 0),
                        percent.format((row?.bindPercentageNoHit ?? 0) / 100),
                    ]); 
                });
            } else { // Policies
                formattedResponse = [["Online"], ["Combo"], ["CRC"], ["Agency"], ["TOTAL"]];
                formattedResponse.forEach(function (item) {
                    var row = response.find(x => x.policyType == item[0]);
                    item.push(...[
                        integer.format(row?.totalPolicies ?? 0),
                        `${integer.format(row?.policies700AndOver ?? 0)} (${percent.format((row?.percentage700AndOver ?? 0) / 100)})`,
                        currency.format(row?.avgPrem700AndOver ?? 0),
                        `${integer.format(row?.policies600To699 ?? 0)} (${percent.format((row?.percentage600To699 ?? 0) / 100)})`,
                        currency.format(row?.avgPrem600To699 ?? 0),
                        `${integer.format(row?.policies599AndUnder ?? 0)} (${percent.format((row?.percentage599AndUnder ?? 0) / 100)})`,
                        currency.format(row?.avgPrem599AndUnder ?? 0),
                        `${integer.format(row?.policiesNoHit ?? 0)} (${percent.format((row?.percentageNoHit ?? 0) / 100)})`,
                        currency.format(row?.avgPremNoHit ?? 0),
                    ]);
                });
            }

            if (props.comments?.length > 0) {
                headers[0].push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row.toLowerCase() == x[0].toLowerCase());
                    x.push(comment ? comment.message : '');
                });
            }

            setData(formattedResponse);
        }
            
        setLoading(false);
    };
        
    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                title={`${props.type.toUpperCase()} - CREDIT-BASED DISCOUNT REQUESTED`}
                loading={loading}
                fixedColumns={1}
                style={{
                    Table: {
                        Body: { whiteSpace: "nowrap" },
                        Footer: { whiteSpace: "nowrap" },
                    }
                }}
                headers={headers}
                rows={data.filter(x => x[0] !== 'TOTAL')}
                footers={data.filter(x => x[0] === 'TOTAL')}
                exportName={`${props.type}CreditBasedDiscountRequested`}
            />
        </div>
    );
};
